import { Ribbon } from '@/kit';
import { useMeta } from '@/app/meta';

/**
 * R-14 T-084 (John at GO, 2026-10-20): every pre-release stage reads "Preview" on the ribbon — the
 * stage code (`alpha`, `beta`) is a developer word and stays in Admin › Settings. The one sentence
 * says what Preview means. `release_stage` itself is unchanged (it still gates CC1 scope rules).
 */
export const PREVIEW_LABEL = 'Preview';
export const PREVIEW_MEANING = 'Data and behaviour can change; not a record.';
const PRE_RELEASE = new Set(['alpha', 'beta', 'preview']);

/**
 * Required on every page for a pre-release build (`release_stage` from /api/meta), as the kit's
 * ribbon (Keylime, Bog text, R-13). Part of the page, not a dismissible toast: a screenshot of a
 * number from a preview has to carry the caveat with it.
 */
export function ReleaseStageBanner() {
  const { releaseStage, appName } = useMeta();
  if (!PRE_RELEASE.has((releaseStage ?? '').toLowerCase())) return null;
  return (
    <Ribbon stage={PREVIEW_LABEL} srText={`: ${appName} release stage`}>
      {PREVIEW_MEANING}
    </Ribbon>
  );
}
